<template>
  <div>
    <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      
      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type">
          <el-option :value="item.form_id" :label="item.name" :key="item.form_id" v-for="item in type"></el-option>
        </el-select>
      </el-form-item>

      <!--名称-->
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" autocomplete="off" placeholder="请输入" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="键值" prop="key_name" :label-width="formLabelWidth">
        <el-input v-model="formData.key_name" autocomplete="off" placeholder="请输入" disabled class="max-w460" style="width:200px"></el-input>
      </el-form-item>

      <!--答案类型-->
      <el-form-item label="答案类型" prop="input_type" :label-width="formLabelWidth">
        <el-select v-model="formData.input_type">
          <el-option :value="item.value" :label="item.text" :key="item.value" v-for="item in input_type"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="参数值" prop="values" :label-width="formLabelWidth" v-if="formData.input_type==3 || formData.input_type==4">
        <!-- <el-input type="textarea" v-model="formData.values" :rows="5" placeholder="请输入"></el-input> -->

        <el-button type="primary" size="small" @click="addValue" :loading="loading" icon="el-icon-plus">添加</el-button>
        <span class="blue ml10" v-if="formData.type == 1">注：【考研择校】键值：0,1,2,3...</span>
        <span class="blue ml10" v-else>注：【表单填写】和【拟排名】键值：A,B,C...</span>
        <span class="red ml10">类型切换完留意键值</span>
        <el-table class="custom mt10" :data="formData.input_values" border stripe>
          <el-table-column label="值" width="80">
            <template slot-scope="scope"><el-input v-model="scope.row.value" style="width:100%"></el-input></template>
          </el-table-column>
          <el-table-column label="名称" width="200">
            <template slot-scope="scope"><el-input v-model="scope.row.text"></el-input></template>
          </el-table-column>
          <el-table-column label="是否需要填写" width="130" v-if="formData.type == 3">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.is_input">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
          </template>
          </el-table-column>
          <el-table-column label="关联显示键值" width="100" v-if="formData.type == 3">
            <template slot-scope="scope"><el-input v-model="scope.row.show" style="width:100%"></el-input></template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a @click="delValue(scope.$index)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!--是否必填-->
      <el-form-item label="是否必填" prop="required" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.required">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--是否默认隐藏-->
      <el-form-item label="是否默认隐藏" prop="is_hidden" :label-width="formLabelWidth" v-if="formData.type == 3">
        <el-radio-group v-model="formData.is_hidden">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--附加条件-->
      <CustomField v-if="formData.type == 3" :label="'附加条件'" :column="column" :fields="formData.condition"></CustomField>

      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model="formData.sort" autocomplete="off" placeholder="请输入" class="max-w460" style="width:200px"></el-input>
      </el-form-item>

      <template v-if="formData.type==1">
      <!--在详情页显示-->
      <el-form-item label="在详情页显示" prop="is_detail" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_detail">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--在对比页显示-->
      <el-form-item label="在对比页显示" prop="is_contrast" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_contrast">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--在对比页显示-->
      <el-form-item label="是否基础搜索" prop="is_basics_search" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_basics_search">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--在对比页显示-->
      <el-form-item label="是否高级搜索" prop="is_advanced_search" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_advanced_search">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--在对比页显示-->
      <el-form-item label="是否导入" prop="is_import" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_import">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      </template>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--上传图片组件-->
  <Upload v-if="is_upload" :isupload="is_upload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import CustomFieldApi from '@/api/study/custom_field.js';
import Upload from '@/components/file/Upload';
import { deepClone } from '@/utils/base.js';
import { alphabet } from '@/utils/base.js';
import CustomField from '@/components/input/field';
export default {
  components: {
    Upload,
    CustomField
  },
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        type: 1,
        name: '',
        key_name: '',
        input_type: '',
        input_values: [],
        condition: [],
        image_id: 0,
        image: '',
        required: 0,
        max: '',
        is_hidden: 0,
        status: 1,
        sort: 100,
      },
      /*验证规则*/
      formRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // key_name: [{ required: true, message: '请输入键值', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*是否上传图片*/
      is_upload: false,
      input_values: [{value:'', text: '', is_input:0, del: ''}],
      column: [
        {type:'input', label:'名称', value:'name', width:120}, 
        {type:'select', label:'键', value:'key', width:100}, 
        {type:'input', label:'值', value:'value', width:100}
      ],
    };
  },
  props: ['open_edit', 'selectModel', 'input_type', 'type'],
  created() {
    this.dialogVisible = this.open_edit;
    this.formData = this.selectModel;
    if (!this.formData.input_values) this.formData.input_values = this.input_values;
    if (!this.formData.condition) this.formData.condition = [];
  },
  methods: {
    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CustomFieldApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
    /*上传*/
    openUpload(e) {
      this.is_upload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        this.formData.image = e[0].file_path;
        this.formData.image_id = e[0].file_id;
      }
      this.is_upload = false;
    },
    addValue(){
      let alp = alphabet();
      let len = this.formData.input_values.length;
      if (this.formData.type == 1){
        this.formData.input_values.push({value:len, text: '', is_input:0, del: ''});
      }else{
        this.formData.input_values.push({value:alp[len], text: '', is_input:0, del: ''});
      }
      
    },
    delValue(index){
      this.formData.input_values.splice(index,1);
    }
  }
};
</script>

<style>
.custom td {
  padding: 5px 0;
}
.custom input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/study/custom/field/part/Edit.vue